// 可以发评论的文章：88g4zyFmKwO
// 评论很多的文章：8KnwPEEA6BF
// 正式的文章：8KvjcPv1rFz
export const ARTICLE_BASE62ID = '8KvjcPv1rFz';
export const COMMENT_ID = `ucms_${ARTICLE_BASE62ID}`;
